import FMCG from "./FMCG.jsx";
export default FMCG